import { AlertSettingToggle } from "./AlertSettingToggle";

export const AlertFirstOnlyToggle = props => (
  <AlertSettingToggle {...props} setting="alert_first_only" />
);
